export default __webpack_public_path__ + "static/media/PlayButtonGreen.3cd99605.svg";